import React, { useState, useEffect } from 'react';
import axios from 'axios';

interface Statistic {
  _id: string;
  value: string;
  label: string;
  description: string;
  order: number;
}

const ByTheNumbersSection: React.FC = () => {
  const [statistics, setStatistics] = useState<Statistic[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        // Get API URL from environment or default
        const apiUrl = process.env.REACT_APP_API_URL || '';
        const response = await axios.get(`${apiUrl}/api/statistics`);
        console.log('✅ Statistics API response:', response.data);
        
        if (response.data.success) {
          setStatistics(response.data.data);
        } else {
          setError('Failed to load statistics');
        }
      } catch (error) {
        console.error('Error fetching statistics:', error);
        setError('Failed to load statistics');
      } finally {
        setLoading(false);
      }
    };

    fetchStatistics();
  }, []);

  if (loading) {
    return (
      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-gray-400">
            <svg className="animate-spin w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Loading statistics...
          </div>
        </div>
      </section>
    );
  }

  if (error || statistics.length === 0) {
    return null; // Don't render section if no data
  }

  return (
    <section className="max-w-7xl mx-auto px-6 py-20">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold mb-4 text-white">
          By the Numbers
        </h2>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
          Our achievements and milestones in blockchain infrastructure excellence
        </p>
      </div>

      <div className="grid grid-cols-4 gap-6 max-w-6xl mx-auto">
        {statistics.map((stat, index) => (
          <div
            key={stat._id}
            className="dashboard-block p-6 text-center card-hover animate-fade-in-up"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="mb-4">
              <div className="text-3xl font-bold pastel-labs mb-2">
                {stat.value}
              </div>
              <div className="text-sm font-semibold text-white mb-2">
                {stat.label}
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              {stat.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ByTheNumbersSection;
